<template>
  <b-popover
    :target="target"
    triggers="click"
    placement="bottom"
    custom-class="download-month-popover"
    :show.sync="visible"
  >
    <div class="w-[320px] p-1 bg-white rounded-[16px]">
      <!-- Header -->
      <div class="flex justify-between items-center mb-2 px-2">
        <b-icon
          icon="chevron-left"
          class="cursor-pointer text-black font-bold"
          @click="prevYear"
        />
        <span class="font-semibold text-[16px] text-black">{{ year }}</span>
        <b-icon
          icon="chevron-right"
          class="cursor-pointer text-black font-bold"
          @click="nextYear"
        />
      </div>

      <!-- Grid Months -->
      <div class="grid grid-cols-4 gap-2 mb-2">
        <div
          v-for="(m, index) in months"
          :key="index"
          class="py-1 rounded-[8px] text-[14px] text-center font-medium transition-colors"
          :class="[
            isDisabled(index) ? 'bg-[#F9FAFB] text-[#A0A0A0] cursor-not-allowed' :
            month === index ? 'bg-[#F95031] text-white cursor-pointer' : 'bg-[#F9FAFB] text-black hover:bg-gray-200 cursor-pointer'
          ]"
          @click="!isDisabled(index) && selectMonth(index)"
        >
          {{ m }}
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="grid grid-cols-2 gap-2 mt-2">
        <b-button
          variant="outline-secondary"
          class="rounded-[8px] text-[14px] font-semibold bg-white text-black border border-[#E5E7EB]"
          @click="close"
        >
          Batal
        </b-button>
        <b-button
          variant="primary"
          class="rounded-[8px] text-[14px] font-semibold text-white border-none bg-[#F95031]"
          @click="handleDownload"
        >
          Download
        </b-button>
      </div>
    </div>
  </b-popover>
</template>

<script>
export default {
  name: 'DownloadMonthPopover',
  props: {
    target: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    }
  },
  methods: {
    prevYear() {
      this.year -= 1
    },
    nextYear() {
      if (this.year < new Date().getFullYear()) {
        this.year += 1
      }
    },
    isDisabled(index) {
      const currentDate = new Date()
      if (this.year > currentDate.getFullYear()) return true
      if (this.year === currentDate.getFullYear() && index > currentDate.getMonth()) return true
      return false
    },
    selectMonth(index) {
      this.month = index
    },
    close() {
      this.visible = false
    },
    handleDownload() {
      this.$emit('download', { year: this.year, month: this.month })
      this.close()
    },
  },
}
</script>

<style>
/* Override default popover styles to match design */
.download-month-popover {
  border: none !important;
  border-radius: 16px !important;
  background: white !important;
  max-width: none !important;
  padding: 0 !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
.download-month-popover .popover-body {
  padding: 0 !important;
}
.download-month-popover .arrow {
  display: none !important;
}
</style>
